<template>
  <div class="app flex-row align-items-center">
    <div class="container animated fadeIn">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <vue-element-loading :active="FORM_LOADING">
                  <img src="img/Spinner-1s-200px.svg">
                </vue-element-loading>
                <b-form @submit.prevent="login">
                  <h1 v-if="this.FORM_MODE !== 'C'">Login</h1>
                  <p class="text-muted" v-if="this.FORM_MODE !== 'C'">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Username"
                      v-model="SignInDATA.username"
                      :invalid-feedback="invalidFeedback_username"
                      :valid-feedback="validFeedback_username"
                      :readonly="this.FORM_MODE === 'R' || this.FORM_MODE === 'C'"
                      :state="state_username"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      v-model="SignInDATA.password"
                      :invalid-feedback="invalidFeedback_password"
                      :valid-feedback="validFeedback_password"
                      :readonly="this.FORM_MODE === 'R' || this.FORM_MODE === 'C'"
                      :state="state_password"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        class="px-4"
                        type="submit"
                        v-if="this.FORM_MODE !== 'C'"
                      >Login</b-button>
                    </b-col>
                  </b-row>
                </b-form>

                <b-form @submit.prevent="ChangePassword" v-if="this.FORM_MODE === 'C'">
                  <h1>Change Password</h1>
                  <p class="text-muted">You must create a new password before using the system</p>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="New password"
                      :invalid-feedback="invalidFeedback_NewPassword"
                      :valid-feedback="validFeedback_NewPassword"
                      v-model="ChangePwdDATA.NewPassword"
                      :readonly="this.FORM_MODE === 'R'"
                      :state="state_NewPassword"
                    />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="Confirm password"
                      :invalid-feedback="invalidFeedback_ConfirmPassword"
                      :valid-feedback="validFeedback_ConfirmPassword"
                      v-model="ChangePwdDATA.ConfirmPassword"
                      :readonly="this.FORM_MODE === 'R'"
                      :state="state_ConfirmPassword"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        class="px-4"
                        type="submit"
                        v-if="this.FORM_MODE === 'C'"
                      >Save</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import VueElementLoading from "vue-element-loading";
import VueAxios from "@/shared/axios-instance.js";

function SignIn_Object(data) {
  this.username = data ? data.username : "";
  this.password = data ? data.password : "";
}

function ChangePassword_Object(data) {
  this.UserId = data ? data.UserId : 0;
  this.NewPassword = data ? data.NewPassword : "";
  this.ConfirmPassword = data ? data.ConfirmPassword : "";
}

export default {
  name: "SignIn",
  components: {
    VueElementLoading
  },
  data() {
    return {
      FORM_MODE: "E", // R: readonly (view details), E: edit, C: Change password
      FORM_LOADING: false,
      SignInDATA: {},
      ChangePwdDATA: {},
      IsSubmitClicked: false
    };
  },
  created() {
    this.SignInDATA = new SignIn_Object();
    this.ChangePwdDATA = new ChangePassword_Object();
  },
  mounted: function() {
  },
  methods: {
    login: function() {
      this.IsSubmitClicked = true;
      if (this.SIGNIN_FORM_STATE === true && this.FORM_MODE === "E") {
        this.FORM_LOADING = true;
        VueAxios.post("/SignIn", this.SignInDATA)
          .then(resp => {
            if (resp.status === 200) {
              this.$myStore.commit("SET_Token", resp.data.token);
              VueAxios.defaults.headers.common["Authorization"] =
                "Bearer " + resp.data.token;

              if (resp.data.IsRequirePasswordChange === true) {
                this.FORM_MODE = "C";
                this.ChangePwdDATA.UserId = resp.data.UserId;
                this.FORM_LOADING = false;
                this.IsSubmitClicked = false;
              } else {
                // Get permissions
                VueAxios.get("/user/me/permissions").then(resp => {
                  this.FORM_LOADING = false;
                  this.FORM_MODE = "R";
                  this.$myStore.commit("SET_Permissions", resp.data);
                  this.$router.push("/dashboard");
                });
              }
            }
          })
          .catch(err => {
            this.FORM_LOADING = false;
            if (err.data && err.data.Message) {
                this.$snotify.error(err.data.Message, 'Error');
              } else if (err.status == 404) {
                const responseURL = err.request && err.request.responseURL ? err.request.responseURL : "";
                this.$snotify.error(`HTTP 404 Error. Cannot find webapi at ${responseURL}`, 'Error');
              } else {
								console.log(err);
							}
          });
      }
    },
    ChangePassword: function() {
      this.IsSubmitClicked = true;
      if (this.CHANGEPWD_FORM_STATE === true && this.FORM_MODE === "C") {
        this.FORM_LOADING = true;
        VueAxios.put("/ChangePwd", this.ChangePwdDATA)
          .then(resp => {
            if (resp.status === 200) {
              // Get permissions
              VueAxios.get("/user/me/permissions").then(resp => {
                this.FORM_LOADING = false;
                this.FORM_MODE = "R";
                this.$myStore.commit("SET_Permissions", resp.data);
                this.$router.push("/dashboard");
              });
            }
          })
          .catch(err => {
            this.FORM_LOADING = false;
            if (err.data && err.data.Message) {
                this.$snotify.error(err.data.Message, 'Error');
							} else {
								console.log(err);
							}
          });
      }
    }
  },
  computed: {
    // input states
    state_username() {
      if (this.IsSubmitClicked === true) {
        return this.SignInDATA.username.length >= 1 ? true : false;
      } else {
        return null;
      }
    },
    state_password() {
      if (this.IsSubmitClicked === true) {
        return this.SignInDATA.password.length >= 1 ? true : false;
      } else {
        return null;
      }
    },

    state_NewPassword() {
      if (this.IsSubmitClicked === true && this.FORM_MODE === "C") {
        return this.ChangePwdDATA.NewPassword.length >= 3 ? true : false;
      } else {
        return null;
      }
    },
    state_ConfirmPassword() {
      if (this.IsSubmitClicked === true && this.FORM_MODE === "C") {
        return this.ChangePwdDATA.ConfirmPassword.length >= 3 &&
          this.ChangePwdDATA.ConfirmPassword == this.ChangePwdDATA.NewPassword
          ? true
          : false;
      } else {
        return null;
      }
    },

    SIGNIN_FORM_STATE() {
      return this.state_username !== false || this.state_password !== false
        ? true
        : false;
    },
    CHANGEPWD_FORM_STATE() {
      return this.state_NewPassword !== false ||
        this.state_ConfirmPassword !== false
        ? true
        : false;
    },

    // invalid feedbacks
    invalidFeedback_username() {
      return this.state_username !== false ? "" : "Username is required.";
    },
    invalidFeedback_password() {
      return this.state_password !== false ? "" : "Password is required.";
    },
    invalidFeedback_NewPassword() {
      return this.state_newPassword !== false ? "" : "Required";
    },
    invalidFeedback_ConfirmPassword() {
      return this.state_ConfirmPassword !== false ? "" : "Required";
    },

    // valid feedbacks
    validFeedback_username() {
      return this.state_username === true ? "" : "";
    },
    validFeedback_password() {
      return this.state_password === true ? "" : "";
    },
    validFeedback_NewPassword() {
      return this.state_newPassword === true ? "" : "";
    },
    validFeedback_ConfirmPassword() {
      return this.state_ConfirmPassword === true ? "" : "";
    }
  }
};
</script>